import { useMutation } from '@apollo/client';
import { gql } from '@apollo/client';
import { useSignedDocumentUpload } from '../../../hooks/useSignedDocumentUpload';
import { Task, createTaskSupportDocumentUrl } from '@admiin-com/ds-graphql';

export const useDownloadSupportDoc = () => {
  const [createTaskSupportDocumentUrlFunc] = useMutation(
    gql(createTaskSupportDocumentUrl)
  );
  const { downloadDocument } = useSignedDocumentUpload();

  const downloadSupportDocument = async (key: string, task: Task) => {
    const urlData = await createTaskSupportDocumentUrlFunc({
      variables: {
        input: {
          taskId: task.id,
          key,
          entityId: task.entityId,
        },
      },
    });
    const url = urlData.data?.createTaskSupportDocumentUrl?.url;
    await downloadDocument(url);
  };

  return downloadSupportDocument;
};
